import { useState } from "react";
import { useDebounce } from "react-use";

export function useReportFilters() {
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const [showExamples, setShowExamples] = useState(true);

  useDebounce(
    () => {
      setDebouncedSearch(search);
    },
    500,
    [search],
  );

  function toggleType(type: string, enabled: boolean) {
    setSelectedTypes((prev) => {
      if (enabled) {
        if (prev.includes(type)) return prev;
        return [...prev, type];
      }
      return prev.filter((t) => t !== type);
    });
  }

  function clearTypes() {
    setSelectedTypes([]);
  }

  return {
    search,
    setSearch,
    debouncedSearch,
    selectedTypes,
    toggleType,
    clearTypes,
    showExamples,
    setShowExamples,
  } as const;
}
